<template>
  <div>
    <CRow>
      <CCol cols="12" md="12" lg="12">
        <b-form>
          <b-form-group :label="$store.state.form.syaratDokumenAdministrasi" label-cols-md="3">
            <Multiselect
              v-model="dokumenId"
              :options="dokumen"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              label="namaKebutuhan"
              track-by="id"
              :placeholder="$store.state.form.syaratDokumenAdministrasiPlaceholder"
            ></Multiselect>
          </b-form-group>

          <b-form-group label-cols-md="3">
            <b-button variant="primary" @click="simpan()">
              {{ $store.state.form.tambahkan }}
            </b-button>
          </b-form-group>
        </b-form>
      </CCol>
    </CRow>

    <CRow>
      <CCol cols="12" md="12" lg="12">
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol cols="12" md="12" lg="12">
        <b-table :items="listDokumen" :fields="fields" stacked="md" responsive show-empty small bordered striped hover>
          <template #cell(no)="item">
            {{ item.index + 1 }}
          </template>
          <template #cell(actions)="item">
            <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="'Hapus Data'" @click="deleteItem(item.index)"> <CIcon name="cil-trash" /> {{ item.actions }} </b-button>
          </template>
        </b-table>
      </CCol>
    </CRow>
    <modal-delete-dok />
  </div>
</template>

<script>
import modalDeleteDok from "./modalDeleteDok.vue";
export default {
  components: {
    modalDeleteDok,
  },
  name: "inputTabDokLoker",
  props: ["dokumen", "listDokumen"],
  data() {
    return {
      dokumenId: "",
      kebutuhan: {},
      fields: [
        {
          key: "no",
          label: "No",
          sortable: true,
          sortDirection: "desc",
          class: "table-number text-center",
        },
        {
          key: "namaKebutuhan",
          label: "Syarat Dokumen Administrasi",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          class: "table-option-1 text-center",
        },
      ],
    };
  },
  computed: {},
  methods: {
    simpan() {
      let vm = this;
      let list = {};
      list.namaKebutuhan = vm.dokumenId.namaKebutuhan;
      list.masterKebutuhanId = vm.dokumenId.id;
      vm.listDokumen.push(list);
      vm.kebutuhan.data = vm.listDokumen;
      vm.$emit("dokumenFromChild", vm.kebutuhan);
    },
    deleteItem(index) {
      this.listDokumen.splice(index, 1);
      this.kebutuhan.data = this.listDokumen;
      this.$emit("dokumenFromChild", this.kebutuhan);
    },
  },
};
</script>
